<template>
  <div class="profile-hero">
    <ProfileImage
      :source="userData.big_thumbnail"
      :accountActive="!userData.accountNotActivated"
    />
    <!-- <img :src="userData.big_thumbnail" /> -->
    <div class="column">
      <watchlist-button
        v-if="userCanUseWatchlist"
        :active="existsInWatchlist"
        @add-to-watchlist="updateWatchlist"
      />

      <div class="mb-2">
        <label>Vereinsvorsitzende/r</label>
        <b>{{ userData.ceo }}</b>
      </div>
      <div class="mb-2">
        <label>Sportlicher Leiter</label>
        <b>{{ userData.sportlicher_leiter }}</b>
      </div>
      <div class="mb-2">
        <label>Cheftrainer/-in</label>
        <b>{{ userData.cheftrainer }}</b>
      </div>
      <div class="mb-2">
        <label>Ansässig in Land</label>
        <div>
          <flag class="flag" :iso="userData.nationality" />
          <b>{{ getNationality }}</b>
        </div>
      </div>
      <div class="mb-2">
        <label>Region/Verband</label>
        <b>{{ userData.verband }}</b>
      </div>
    </div>

    <div v-if="userData.category" class="column">
      <div class="mb-2">
        <label>Aktuelle Liga</label>
        <b>{{ userData.category.league }}</b>
      </div>
    </div>
    <div class="column">
      <div class="mb-2">
        <label>Aktueller Bedarf</label>
        <b>{{ userData.will_be_found_by }}</b>
      </div>
    </div>

    <ProfilLinks :userData="userData" />

    <div class="column-span mt-2 pb-2">
      <label>Bio</label>
      {{ userData.bio }}
    </div>
  </div>
</template>

<script>
import ProfileImage from './ProfileImage';
import ProfilLinks from './ProfilLinks.vue';
import WatchlistButton from '@/components/profile/WatchlistButton.vue';
import watchlistMixin from '@/mixins/watchlist';

export default {
  name: 'profile-team-data',

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    ProfileImage,
    ProfilLinks,
    WatchlistButton,
  },

  mixins: [watchlistMixin],

  computed: {
    formatFoundedDate() {
      if (!this.user_data.founded) return null;

      const [year, month, day] = this.user_data.founded.split('-');
      return `${day}.${month}.${year}`;
    },

    getNationality() {
      if (this.userData.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.userData.nationality,
        );
        return found.item_text;
      }
      return '';
    },
  },
};
</script>
